const MODAL_OPEN_CLASS = 'active';
const openModals = new Map(); // overlay element -> release function from manageDialogFocus

/**
 * Opens a modal overlay: locks page scroll where the user is, marks it as a dialog and moves focus in.
 * @param {HTMLElement} modal - The `.modal-overlay` element.
 */
function openModalOverlay(modal) {
  if (openModals.has(modal)) return;

  const panel = modal.firstElementChild;
  modal.classList.add(MODAL_OPEN_CLASS);
  panel.classList.add(MODAL_OPEN_CLASS);

  panel.setAttribute('role', 'dialog');
  panel.setAttribute('aria-modal', 'true');
  lockBodyScroll();

  // Escape goes through the dismiss button so every listener bound to it (location.js) still runs.
  const release = manageDialogFocus(panel, {
    onEscape: () => modal.querySelector('[data-dismiss="modal-selector"]')?.click(),
  });

  openModals.set(modal, release);
}

/**
 * Closes a modal overlay and restores scroll position and focus.
 * @param {HTMLElement} modal - The `.modal-overlay` element.
 * @param {{ restoreFocus?: boolean }} [options]
 */
function closeModalOverlay(modal, { restoreFocus = true } = {}) {
  const panel = modal.firstElementChild;
  modal.classList.remove(MODAL_OPEN_CLASS);
  panel.classList.remove(MODAL_OPEN_CLASS);

  panel.removeAttribute('role');
  panel.removeAttribute('aria-modal');

  const release = openModals.get(modal);
  if (!release) return;

  openModals.delete(modal);
  unlockBodyScroll();

  release({ restoreFocus });
}

// Method to handle modal triggers
document.querySelectorAll('[data-toggle="modal-selector"]').forEach(function (trigger) {
  trigger.addEventListener('click', function () {
    const target = this.getAttribute('data-target');
    const modal = document.querySelector('[data-modal="' + target + '"]');
    if (modal) openModalOverlay(modal);
  });
});

// Method to handle modal triggers close buttons
document.querySelectorAll('[data-dismiss="modal-selector"]').forEach(function (button) {
  button.addEventListener('click', function () {
    const modal = this.closest('.modal-overlay');

    if (modal) closeModalOverlay(modal);
  });
});

// Clicking the dimmed backdrop (not the panel) closes the modal, as its pointer cursor suggests.
document.querySelectorAll('.modal-overlay').forEach(function (overlay) {
  overlay.addEventListener('click', function (event) {
    if (event.target !== overlay || !openModals.has(overlay)) return;

    overlay.querySelector('[data-dismiss="modal-selector"]')?.click();
  });
});

// From lg the filters render inline, so an open overlay would leave the page scroll-locked.
watchMediaQuery(MEDIA_QUERY.BELOW_LG, (isBelowLg) => {
  if (isBelowLg) return;

  [...openModals.keys()].forEach((modal) => closeModalOverlay(modal, { restoreFocus: false }));
});
